import ContentCutIcon from '@mui/icons-material/ContentCut';
import { IconButton } from "@mui/material";
import { BaseEdge,EdgeLabelRenderer,Position } from "@xyflow/react";
import { getBezierPath } from "@xyflow/system";

//#region Componente estilizado do Edge
export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}: {
  id: string;
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  sourcePosition: Position;
  targetPosition: Position;
  style?: React.CSSProperties;
  markerEnd?: string;
  data?: {
    onDelete?: (id: string) => void;
  };
}) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const onDelete = () => {
    data?.onDelete?.(id);
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            pointerEvents: "all",
          }}
        >
          <IconButton onClick={onDelete}>
            <ContentCutIcon />
          </IconButton>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}//#endregion